export default "__VITE_ASSET__DV1IAzK0__"